module.exports = __webpack_public_path__ + "img/browser-tips.ee448999.ee448999.png";